import React from 'react';
import Logo from '../../assets/img/logo-blackbelt-nova.png';
import { footer } from '../../content/siteContent';
import { StrokeIcon, WhatsAppIcon } from './Icons';

export default function Footer() {
  const { about, social, navItems, contacts, addresses, dpoEmail } = footer;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div>
          <a href="#inicio" className="brand-logo-link footer-brand-link" aria-label="BlackBelt IT Solutions - Início">
            <span className="footer-logo-plate">
              <img src={Logo} alt="BlackBelt IT Solutions" className="official-logo-img" width="185" />
            </span>
          </a>
          <p className="footer-about">{about}</p>
          <div className="social-links">
            {social.map((item) => (
              <a key={item.href} href={item.href} target="_blank" rel="noopener noreferrer" className="social-btn" aria-label={item.label}>
                <StrokeIcon name={item.icon} size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="footer-col-title">Navegação</h4>
          <ul className="footer-links-list">
            {navItems.map((item) => (
              <li key={item.href}>
                <a href={item.href}>{item.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="footer-col-title">Canais de Contato</h4>
          <ul className="footer-links-list">
            <li className="footer-contact-item">
              <StrokeIcon name="phone" size={16} />
              <a href={contacts.phone.href}>{contacts.phone.label}</a>
            </li>
            <li className="footer-contact-item">
              <WhatsAppIcon size={16} />
              <a id="Whatsapp" href={contacts.whatsapp.href} target="_blank" rel="noopener noreferrer">
                {contacts.whatsapp.label}
              </a>
            </li>
            <li className="footer-contact-item">
              <StrokeIcon name="mail" size={16} />
              <a href={contacts.email.href}>{contacts.email.label}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="footer-col-title">Endereços</h4>
          {addresses.map((address) => (
            <div className="footer-address" key={address.unit}>
              <strong>{address.unit}</strong>
              {address.lines.map((line) => (
                <React.Fragment key={line}>
                  <br />
                  {line}
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <div>&copy; {new Date().getFullYear()} BlackBelt IT Solutions. Todos os direitos reservados.</div>
        <div className="dpo-notice">
          <StrokeIcon name="shield" size={16} />
          <span>
            Privacidade e Titular de Dados: Fale com nosso DPO em <a href={`mailto:${dpoEmail}`}>{dpoEmail}</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
